<template>
  <div class="p-cultural">
    <!--头部1-->
    <div class="title kf-animate kf-animate-img">
      <div class="title_text">
        <p>文化和价值观</p>
      </div>
    </div>
    <!--内容-->
    <div class="g-box">
      <div class="thr-box">
        <div class="box">
          <img class="icon" src="@/assets/img/about/cultural/icon.png" />
          <img class="icon0" src="@/assets/img/about/cultural/icon0.png" />
          <p class="text">使命</p>
          <p class="text1">赋能细分领域人才培养</p>
          <p class="text1">赋能区域产业经济发展</p>
        </div>
        <div class="box">
          <img class="icon1" src="@/assets/img/about/cultural/icon1.png" />
          <img class="icon2" src="@/assets/img/about/cultural/icon2.png" />
          <p class="text">愿景</p>
          <p class="text1">打造继续教育终身学习平台</p>
        </div>
        <div class="box">
          <img class="icon1" src="@/assets/img/about/cultural/icon3.png" />
          <img class="icon2" src="@/assets/img/about/cultural/icon4.png" />
          <p class="text">核心价值观</p>
          <p class="text1">热爱学习，善于分享</p>
          <p class="text1">懂得感恩，乐于付出</p>
          <p class="text1">坚守原则，勇于担当</p>
          <p class="text1">拥抱变化，赋能成长</p>
        </div>
      </div>
      <div class="nav">
        <div class="swiper-container" id="swiper1">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) of list"
              :key="index"
            >
              <div class="big">
                <div
                  class="left_img"
                  :style="{ backgroundImage: 'url(' + item.image + ')' }"
                ></div>
                <div class="right_content">
                  <p class="right_title">{{ item.title }}</p>
                  <p class="right_time">{{ item.tips }}</p>
                  <p class="right_text" v-html="item.content"></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="sm">
          <div class="swiper-container" id="swiper2" style="width: 780px">
            <div class="swiper-wrapper">
              <div
                class="sm_img swiper-slide"
                v-for="(item, index) of list"
                :key="index"
              >
                <div
                  :style="{ backgroundImage: 'url(' + item.image + ')' }"
                ></div>
              </div>
            </div>
          </div>
          <div class="btn">
            <div class="swiper-button-prev left_btn">
              <img src="@/assets/img/icon/iconleft.png" />
            </div>
            <div class="swiper-button-next right_btn">
              <img src="@/assets/img/icon/iconright.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--mid-->
    <div class="mid kf-animate kf-animate-img">
      <div class="mid_text">
        <p>员工活动集锦</p>
      </div>
    </div>
    <!--员工集锦-->
    <div
      class="g-box pic_box"
      :style="{
        backgroundImage: 'url(' + staffImg + ')',
      }"
    ></div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
import Swiper from "swiper/swiper-bundle";
export default {
  mixins: [page_mx],
  data() {
    return {
      staffImg: "",
    };
  },
  mounted() {},
  methods: {
    async init() {
      this.params = this.$route.params;
      this.getAjax();
      this.staffImg = await this.getMenuConfig("员工风采", "image");
    },
    async getAjax() {
      await this.getListAndInfo();
      this.$nextTick(() => {
        this.UserSwiper();
      });
    },
    UserSwiper() {
      var thumbsSwiper = new Swiper("#swiper2", {
        loop: false,
        slidesPerView: 4,
        spaceBetween: 20,
        watchSlidesVisibility: true, //防止不可点击
      });
      new Swiper("#swiper1", {
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        disabledClass: "my-button-disabled",
        thumbs: {
          swiper: thumbsSwiper,
          slideThumbActiveClass: "my-slide-thumb-active",
        },
      });
    },

    // getIndex(id) {
    //   this.num = id;
    // },
    // next() {
    //   var len = this.list_img.length;
    //   if (this.num != len - 1) {
    //     this.num++;
    //   } else {
    //     this.num = 0;
    //   }
    // },
    // prev() {
    //   if (this.num > 0) {
    //     this.num--;
    //   }
    // },
  },
};
</script>
<style lang="less" scoped>
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 80px;
  width: 100%;
  height: 280px;
  background: url(~@/assets/img/about/cultural/title.png) no-repeat center;
  background-size: cover;
}
.title_text {
  height: 84px;
  font-size: 60px;
  font-weight: 200;
  color: #ffffff;
  text-align-last: justify;
  text-align: justify;
  line-height: 84px;
  letter-spacing: 20px;
}
.mid {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 80px;
  width: 100%;
  height: 200px;
  background: url(~@/assets/img/about/cultural/mid.png) no-repeat;
  background-size: cover;
}
.mid_text {
  height: 84px;
  font-size: 60px;
  font-weight: 200;
  color: #ffffff;
  text-align-last: justify;
  text-align: justify;
  line-height: 84px;
  letter-spacing: 20px;
}
.thr-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 80px;
}
.box {
  position: relative;
  width: 354px;
  height: 360px;
  background: #f2f4f9;
  .icon,
  .icon0,
  .icon2,
  .icon1 {
    margin-top: 50px;
    margin-left: 39px;
  }
  .icon3,
  .icon4 {
    position: absolute;
    top: 50px;
    right: 28px;
  }
  .icon0,
  .icon2,
  .icon4 {
    display: none;
  }
  .text {
    height: 45px;
    font-size: 32px;
    font-weight: 400;
    color: #002072;
    line-height: 45px;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 39px;
  }
  .text1 {
    width: 275px;
    height: 40px;
    font-size: 22px;
    font-weight: 400;
    color: #656878;
    line-height: 24px;
    margin-left: 39px;
  }
}
.box:hover {
  background: #0030aa;
  .text {
    color: #ffffff;
  }
  .text1 {
    color: #ffffff;
  }
  .icon0,
  .icon2,
  .icon4 {
    display: block;
  }
  .icon,
  .icon1,
  .icon3 {
    display: none;
  }
}
.box1 {
  position: relative;
  width: 354px;
  height: 360px;
  background: #f2f4f9;
  .text {
    height: 45px;
    font-size: 32px;
    font-weight: 400;
    color: #002072;
    line-height: 45px;
    margin-top: 116px;
    margin-left: 39px;
  }
  .text1 {
    width: 275px;
    height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #656878;
    line-height: 40px;
    margin-top: 40px;
    margin-left: 39px;
  }
  .icon3,
  .icon4 {
    position: absolute;
    left: 45px;
    top: 50px;
  }
  .icon1,
  .icon2 {
    position: absolute;
    top: 50px;
    left: 201px;
  }
  .icon,
  .icon0 {
    position: absolute;
    top: 50px;
    left: 266px;
  }
  .icon4,
  .icon2,
  .icon0 {
    display: none;
  }
}
.box1:hover {
  background: #0030aa;
  .text {
    color: #ffffff;
  }
  .text1 {
    color: #ffffff;
  }
  .icon4,
  .icon2,
  .icon0 {
    display: block;
  }
  .icon1,
  .icon3,
  .icon {
    display: none;
  }
}
.nav {
  .big {
    display: flex;
    justify-content: space-between;
    margin-bottom: 100px;
    .left_img {
      width: 540px;
      height: 360px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
    .right_content {
      width: 520px;
      .right_title {
        height: 40px;
        font-size: 28px;
        font-weight: 400;
        color: #000000;
        line-height: 40px;
      }
      .right_time {
        width: 182px;
        height: 25px;
        font-size: 18px;
        font-weight: 400;
        color: #a8aab8;
        line-height: 25px;
        margin-top: 20px;
        margin-bottom: 40px;
      }
      .right_text {
        width: 520px;
        height: 182px;
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        line-height: 26px;
      }
    }
  }
  .sm {
    margin-bottom: 100px;
    display: flex;
    justify-content: space-between;
    .sm_img {
      div {
        width: 180px;
        height: 120px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
    }
    .btn {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      width: 120px;
      height: 120px;

      .left_btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
        background: #ff8012;
        border-radius: 2px;
      }
      .right_btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
        background: #ff8012;
        border-radius: 2px;
      }
    }
  }
}
.pic_box {
  height: 1260px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  margin-bottom: 120px;
}
//.pic_box1 {
//  display: flex;
//  justify-content: space-between;
//  margin-bottom: 20px;
//  .box1_pic1 {
//    width: 480px;
//    height: 360px;
//    background: url(~@/assets/img/about/cultural/bigimg.png) no-repeat;
//    background-size: cover;
//  }
//  .box1_pic2 {
//    width: 290px;
//    height: 360px;
//    background: url(~@/assets/img/about/cultural/bigimg.png) no-repeat;
//    background-size: cover;
//  }
//}
//.pic_box2 {
//  display: flex;
//  justify-content: space-between;
//  .box2_right {
//    display: flex;
//    flex-wrap: wrap;
//    justify-content: space-between;
//    align-content: space-between;
//    width: 730px;
//  }
//  .box2_pic1 {
//    width: 350px;
//    height: 500px;
//    background: url(~@/assets/img/about/cultural/bigimg.png) no-repeat;
//    background-size: cover;
//  }
//  .box2_pic2 {
//    width: 355px;
//    height: 240px;
//    background: url(~@/assets/img/about/cultural/bigimg.png) no-repeat;
//    background-size: cover;
//  }
//  .box2_pic3 {
//    width: 730px;
//    height: 240px;
//    background: url(~@/assets/img/about/cultural/bigimg.png) no-repeat;
//    background-size: cover;
//  }
//}
.swiper-container {
  margin: 0;
}
.my-slide-thumb-active {
  width: 180px;
  height: 120px;
  border: 3px solid #ff8012;
}
</style>
